<template lang="pug">
v-main
  v-container(fluid)
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title {{ title }}
      v-divider
      v-card-text
        h3(style="font-weight: 400; color: black") Welcome to i-Memo TechConnect
        p.mt-2 This iMemo is platform will support all NonGroup memo activities
        .mt-5.pa-6.custom-border.image-head
          .text-center
            h2 Getting started
            p.mt-2 Great to have you on board! Feel free to explore, or get a head start below.
          v-row
            v-col(cols="6", md="4")
              router-link(:to="{ name: 'Users' }")
                v-card.custom-card(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile
                ) 
                  |
                  |
                  |
                  |
                  v-icon.card-icon person_pin
                  .card-title Start Creating User
                  .card-subtitle Create a new user and work with rest of the team.
            v-col(cols="6", md="4")
              router-link(:to="{ name: 'Faq' }")
                v-card.custom-card.blinking(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile,
                  @click="clickCard"
                ) 
                  |
                  |
                  |
                  |
                  v-icon.card-icon live_help
                  .card-title Frequently Asked Questions
                  .card-subtitle Have a question about iMemo? We are here to help.
                  div(style="float: inline-start")
                    lottie-animation.img-icon(
                      v-if="animationTime == 1 && animationPointer == false",
                      ref="anim",
                      :animationData="require('../assets/pointer_blue.json')",
                      :loop="3",
                      :autoPlay="true",
                      @complete="complete",
                      style="width: 100px; height: 100px; margin-left: -50px; float: left; margin-top: -45px"
                    )
            v-col(cols="6", md="4")
              router-link(:to="{ name: 'Data BU' }")
                v-card.custom-card(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile
                ) 
                  |
                  |
                  |
                  |
                  v-icon.card-icon image
                  .card-title Start Edit Logo
                  .card-subtitle Edit business unit logo and business unit tagline

        .mt-5.pa-6.custom-border.bg-gray(v-if="changeLog.releaseDate")
          p.title__feature(
            style="margin: 0; font-family: Roboto; font-size: 20px; font-weight: 400; line-height: 23px; letter-spacing: 0em; text-align: left"
          ) Feature New Release v{{ changeLog.version }} - {{ changeLog.releaseDate }}
            img(
              src="../assets/icon/Vector.png",
              style="width: 22px; vertical-align: middle; margin: 0.2rem"
            )
            p(
              style="margin: 0; padding-top: 0.4rem; font-size: 16px; font-weight: 400; line-height: 30px; letter-spacing: 0em; text-align: left",
              v-for="(item, index) in changeLog.changes",
              :key="index"
            ) {{ index + 1 }}. {{ item }}
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import axios from "axios";
export default {
  name: "HomeUsers",
  components: {
    LottieAnimation,
  },
  props: {
    title: "",
  },
  data() {
    return {
      changeLog: {},
      animationPointer: true,
      animationTime: 0,
    };
  },
  mounted() {
    // axios.get(`${process.env.VUE_APP_API}/requests/serverTime`)
    // .then(({data})=> {
    this.checkAnimation();
    this.getReleaseNote();
    // })
  },
  methods: {
    getReleaseNote() {
      // const IMEMO_VERSION_DATE = new Date(`${process.env.IMEMO_VERSION_DATE}T23:59:59`)
      // const isExpire = Math.ceil((SERVER_TIME - IMEMO_VERSION_DATE) / 24 / 60 / 60 / 1000) >= +process.env.IMEMO_VERSION_EXPIRE_IN_DAYS;
      // if (!isExpire) {
      axios
        .post(
          `${process.env.VUE_APP_API}/release-info/list`,
          {
            role: ["admin"],
            version: process.env.IMEMO_VERSION,
            sortBy: "createdAt",
            direction: 1,
            page: 1,
            perPage: -1,
            keyword: "",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          this.changeLog = res.data.data[res.data.data.length - 1];
          if (this.changeLog) {
            const monthNames = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ];
            let dt = new Date(this.changeLog.releaseDate);
            var d = dt.getDate();
            var m = monthNames[dt.getMonth()]; //Month from 0 to 11
            var y = dt.getFullYear();
            this.changeLog.releaseDate =
              (d <= 9 ? "0" + d : d) + " " + m + " " + y;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      // }
    },

    checkAnimation() {
      if (localStorage.animationPointer == null) {
        this.animationPointer = false;
      }
      if (localStorage.animationTime !== "0") {
        this.animationTime = 1;
      }
    },
    clickCard() {
      this.animationPointer = true;
      localStorage.setItem("animationPointer", true);
    },
    complete() {
      this.animationTime = 0;
      localStorage.setItem("animationTime", 0);
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div .image-head {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.v-toolbar__content {
  box-shadow: none;
}

a {
  text-decoration: none;
}

.custom-card {
  padding: 3rem;
  text-align: center;
}

.card-title {
  font-size: 16px;
  color: #646464;
  font-weight: 600;
}

.card-subtitle {
  font-size: 14px;
  color: #a7a7a7;
}

.theme--light.v-card .custom-card:hover {
  background: #1976d2;
  color: #fff !important;
}

.theme--light.v-card .custom-card:hover .card-title {
  color: #fff;
}

.theme--light.v-card .custom-card:hover .card-subtitle {
  color: #fff;
}

.theme--light.v-card .custom-card:hover .card-icon {
  color: #fff !important;
}

.card-icon {
  color: #1976d2 !important;
  margin-bottom: 0.4rem;
}

.custom-card.theme--light.v-sheet--outlined {
  border: 2px solid #efeff0;
}

.blinking {
  animation-name: blinking;
  animation-duration: 1s;
  animation-iteration-count: 100;
}
@keyframes blinking {
  50% {
    border: 2px solid #1976d2;
  }
}

.custom-border {
  border: 1px solid #1976d2 !important;
  border-radius: 3px;
}

.title__feature {
  color: #000000;
  font-size: 16px;
}

.bg-gray {
  background: #f2f2f2;
}
</style>